import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getStorePerformances } from '../../../actions/store-performance';
import ObjectivePerformances from '../../store-performance/objective-performances';
import { pages } from '../../store-performance';

class StorePerformance extends Component {
  panelRefs = {};
  state = {
    openPanels: [],
  };

  handleClick = (key) => {
    const { openPanels } = this.state;

    if (openPanels.includes(key)) {
      this.setState({
        openPanels: openPanels.filter(panelKey => panelKey !== key),
      });
    } else {
      this.setState({
        openPanels: [...openPanels, key],
      });
    }
  };

  componentWillMount() {
    const { dispatch, outletId } = this.props;

    dispatch(getStorePerformances(outletId));
  }

  render() {
    const { openPanels } = this.state;

    return (
      <ObjectivePerformances
        pages={pages}
        panelRefs={this.panelRefs}
        openPanels={openPanels}
        handleClick={this.handleClick}
      />
    );
  }
}

export default connect()(StorePerformance);



// WEBPACK FOOTER //
// ./src/components/team/store-details/store-performance.jsx